<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (alt)="alt()"
  (cancel)="cancel()"
  (confirm)="confirmEditFertilizationSettings($event)"
  data-test="edit-all-fertilization-settings"
>
  <div class="flex--column flex--nowrap" style="height: 100%">
    <mat-form-field
      class="text--body full-width-field flex__child--auto"
      data-test="quick-edit-search"
      style="max-height: 5rem"
    >
      <input
        #search
        type="text"
        [placeholder]="'search' | translate"
        [formControl]="searchControl"
        matInput
        data-test="quick-edit-search-input"
      />
      @if (isSearching) {
        <button
          mat-icon-button
          matSuffix
          (click)="closeSearch()"
          data-test="quick-edit-closeSearch"
        >
          <mat-icon>clear</mat-icon>
        </button>
      }
    </mat-form-field>

    <div class="flex__child--auto" style="overflow: auto">
      <agr-notification-empty
        [isEmpty]="relevantFertilizationSettings?.length === 0"
        [emptyTitle]="(isSearching ? 'noCropFieldsSearchTitle' : 'noCropFieldsTitle') | translate"
        [emptyDescription]="
          (isSearching ? 'noCropFieldsSearchDescription' : 'noCropFieldsDescription') | translate
        "
        emptyActionIcon="clear"
        [emptyActionText]="'resetCropFieldSearch' | translate"
        [showEmptyAction]="isSearching"
        [emptyImage]="false"
        (emptyAction)="closeSearch()"
        class="cropfield-grid"
        style="overflow: visible"
      >
        @if (!renderQuickEditFormComponents) {
          <mat-spinner class="prerender-spinner" [diameter]="75"></mat-spinner>
        }

        @if (renderQuickEditFormComponents) {
          <mat-list class="fertilization-settings-list" data-test="all-fertilization-settings-list">
            @for (
              fertilizationSetting of relevantFertilizationSettings;
              track trackByFertilizationSetting(i, fertilizationSetting);
              let i = $index
            ) {
              <mat-list-item
                class="fertilizationsetting-row"
                data-test="quick-edit-fertilization-setting-item"
              >
                <div
                  [ngClass]="{ 'border-top--black': i !== 0 }"
                  class="fertilizationsetting-row__wrapper"
                >
                  <app-fertilization-setting-detail
                    [formGroup]="formGroupByFertilizationSettingId[fertilizationSetting.id]"
                    [data]="data"
                    [fertilizationSetting]="fertilizationSetting"
                    [adviceId]="fertilizationSetting.adviceId"
                  >
                  </app-fertilization-setting-detail>
                </div>
              </mat-list-item>
            }
          </mat-list>
        }
      </agr-notification-empty>
    </div>
  </div>
</agr-form-dialog>
